export default {
  siteName: '性福寶',
  siteSlogan: '讓每一刻更幸福',
  home: '首頁',
  products: '產品系列',
  articles: '健康資訊',
  about: '關於我們',
  orderNow: '立即訂購',
  learnMore: '了解更多',
  viewAll: '查看全部',
  contactUs: '聯繫我們',
  sendMessage: '發送訊息',
  subscribe: '立即訂閱',
  readMore: '閱讀更多',
  backToList: '返回列表',
  notFound: '頁面未找到',
};